export default {"theme":{"dark":false,"themes":{"light":{"primary":"#ff5340","accent":"#ff5340","info":"#3abbd5","success":"#65ad25","black":"#111"}}},"icons":{"iconfont":"mdi"}}
